import Send from '../send';

const DEFAULT_API = '/v1/host-info';
export default {
    hostInfoList(siteInfoSeq) {
        return Send({
            url : `${DEFAULT_API}/list`,
            method : 'GET',
            params : {
                siteInfoSeq : siteInfoSeq
            }
        });
    },

    hostInfoListByPage(siteInfoSeq, pageNumber) {
        return Send({
            url : `${DEFAULT_API}/list?page=${pageNumber}`,
            method : 'GET',
            params : {
                siteInfoSeq : siteInfoSeq
            }
        });
    },

    hostInfoListBySiteInfoHostName(siteInfoSeq, hostName) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'GET',
            params : {
                siteInfoSeq : siteInfoSeq,
                hostName : hostName
            }
        });
    },

    hostInfoListByHostName(hostName) {
        return Send({
            url : `${DEFAULT_API}/only-name`,
            method : 'GET',
            params : {
                hostName : hostName
            }
        });
    },

    login(email, password) {
        return Send({
            url : `${DEFAULT_API}/login`,
            method : 'GET',
            params : {
                email : email,
                passwrd: password
            }
        });
    },

    uploadByExcel (siteInfoSeq, file) {
        const formData = new FormData();
        formData.append('siteInfoSeq', siteInfoSeq);
        formData.append('file', file);
        return Send({
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            method : 'post',
            url : `${DEFAULT_API}/excel/import`,
            data : formData
        });
    },

    excelDownloadHostInfo(siteInfoSeq) {
        // window.location.href=`${DEFAULT_API}/excel/download?siteInfoSeq=${siteInfoSeq}`;
        // Send({
        //     url : `${DEFAULT_API}/excel/download`,
        //     method : 'GET',
        //     params : {
        //         siteInfoSeq : siteInfoSeq
        //     }
        // });
    },

    deleteHostInfo(number) {
        return Send({
            url : `${DEFAULT_API}/delete`,
            method : 'DELETE',
            params : {
                number : number
            }
        });
    },

    changePassword(number, prevPassword, nextPassword) {
        return Send({
            url : `${DEFAULT_API}/change-password`,
            method : 'POST',
            params : {
                number : number,
                prevPassword : prevPassword,
                nextPassword : nextPassword,
            }
        });
    },
}